export default [
	{
		"value": "xlsx",
		"name": "Excel"
	},
	{
		"value": "docx",
		"name": "Word"
	},
	{
		"value": "pptx",
		"name": "Power Point"
	},
	{
		"value": "mpp",
		"name": "Project"
	},
	{
		"value": "vsd",
		"name": "Visio"
	}
];
